"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var inkBar = function inkBar(theme) {
  return /*#__PURE__*/(0, _react.css)("height:", (0, _util.rem)(3), ";background-color:", theme.color.tabs.inkBarBg, ";pointer-events:none;position:absolute;bottom:0;transition:width 0.3s,left 0.3s,right 0.3s;" + (process.env.NODE_ENV === "production" ? "" : ";label:inkBar;"));
};

var tabsList = function tabsList(theme) {
  return /*#__PURE__*/(0, _react.css)("display:flex;flex-wrap:nowrap;white-space:nowrap;position:relative;padding-bottom:", (0, _util.rem)(15), ";color:", theme.color.tabs.tabText, ";-webkit-overflow-scrolling:touch;overflow-x:auto;&::-webkit-scrollbar{display:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:tabsList;"));
};

var backBtnWrapper = function backBtnWrapper(theme) {
  return /*#__PURE__*/(0, _react.css)("border-right:1px solid ", theme.color.monochrome.medium, ";margin-right:", theme.spacing[10], ";display:flex;align-items:center;button{color:", theme.color.monochrome.mediumDark, ";margin:0;padding:0 ", theme.spacing[10], " 0 ", theme.spacing[5], ";&>span{display:inline-block;position:relative;top:", theme.spacing[1], ";width:", theme.spacing[8], ";height:", theme.spacing[8], ";transition:all 0.2s;&::before,&::after{position:absolute;display:block;content:'';}&::before{width:", theme.spacing[6], ";height:", theme.spacing[6], ";border-top:2px solid;border-left:2px solid;border-color:currentColor;top:50%;left:2px;transform-origin:0% 0%;transform:rotatez(-45deg);}&::after{width:", theme.spacing[6], ";height:", theme.spacing[2], ";top:50%;background-color:currentColor;transition:width 0.2s,margin 0.2s;transform:translate(5px, -50%);}}&:hover{color:", theme.color.primary.brand, ";&>span{margin-left:-2px;margin-right:2px;&::after{width:", theme.spacing[7], ";margin-left:-2px;}}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:backBtnWrapper;"));
};

var backBtnWrapperSmall = function backBtnWrapperSmall(theme) {
  return /*#__PURE__*/(0, _react.css)("button{&>span{&::before{width:", theme.spacing[5], ";height:", theme.spacing[5], ";}&::after{width:", theme.spacing[5], ";}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:backBtnWrapperSmall;"));
};

var styles = {
  inkBar: inkBar,
  tabsList: tabsList,
  backBtnWrapper: backBtnWrapper,
  backBtnWrapperSmall: backBtnWrapperSmall
};
exports.styles = styles;
//# sourceMappingURL=Tabs.styles.js.map